import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import clsx from 'clsx';

const Wrapper = styled.div`
    > * {
        opacity: 0;
        animation-duration: 2s;
    }
`;

export function VideoPlayer({ src, timeout = 0, height = 360 }) {
    const [shouldPlay, setShouldPlay] = useState(false);

    useEffect(() => {
        const timeoutRef = setTimeout(() => setShouldPlay(true), timeout);
        return () => clearTimeout(timeoutRef);
    }, []);

    return (
        <Wrapper style={{ height }}>
            <div className={clsx(shouldPlay && 'animate__animated animate__fadeIn')}>
                <ReactPlayer url={src} playing={shouldPlay} loop height={height} muted width="100%" playsinline />
            </div>
        </Wrapper>
    );
}
